var WxIconComponent = /** @class */ (function () {
    function WxIconComponent() {
    }
    Object.defineProperty(WxIconComponent.prototype, "tooltip", {
        /**
         * Returns a tooltip to display to the user when hovering over the flight category
         */
        get: function () {
            return this.flightCategory ? '' : 'Flight category unknown';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WxIconComponent.prototype, "cssClass", {
        /**
         * Returns the CSS classes to set on the root element based on flight category
         */
        get: function () {
            return {
                'wx-icon--lifr': this.flightCategory === 'LIFR',
                'wx-icon--ifr': this.flightCategory === 'IFR',
                'wx-icon--mvfr': this.flightCategory === 'MVFR',
                'wx-icon--vfr': this.flightCategory === 'VFR'
            };
        },
        enumerable: true,
        configurable: true
    });
    return WxIconComponent;
}());
export { WxIconComponent };
